<template>
   <div id="productlist">
       <div class="tos">
          <el-form :inline="true" :model="productQueryPageDto" label-width="100px"  class="demo-form-inline">
             <el-form-item label="关键字：">
                <el-input v-model="productQueryPageDto.keyWord"></el-input>
             </el-form-item>
             <el-form-item label="产品分类：">
               <el-select v-model="productQueryPageDto.cateId" clearable placeholder="请选择产品分类">
                     <el-option
                        v-for="item in ydyoptions"
                        :key="item.cateId"
                        :label="item.cateName"
                        :value="item.cateId">
                     </el-option>
                  </el-select>
             </el-form-item>
             <el-form-item>
                <el-button type="primary" @click="sjhsearchFor()" plain>查询</el-button>
             </el-form-item>
          </el-form>
          <el-button class="left_item" type="primary" @click=tjggnewoks()>发布产品</el-button>
       </div>
       <div class="tjannos">
       </div>
       <div class="tableform">
         <el-table
             :data="tableData"
             border
             stripe
             :cell-style="{'text-align':'center'}"
             :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
             style="width: 100%">
             <el-table-column
                prop="productTitle"
                label="产品名称"
                >
                <template slot-scope="{row:{ productTitle }}">
                {{ productTitle|| "—" }}
                </template>
             </el-table-column>
             <el-table-column
                prop="cateName"
                label="产品分类"
                >
                <template slot-scope="{row:{ cateName }}">
                {{ cateName|| "—" }}
                </template>
             </el-table-column>
             <el-table-column
                prop="status"
                label="产品状态"
                >
                <template slot-scope="scope">
               <el-tag
                  :type="scope.row.status === '下架' ? 'danger' : 'warning'"
                  disable-transitions>{{scope.row.status}}</el-tag>
               </template>
             </el-table-column>
             <el-table-column
                prop="showStatus"
                label="是否显示在首页"
                >
                <template slot-scope="scope">
               <el-tag
                  :type="scope.row.showStatus === '是' ? 'primary' : 'success'"
                  disable-transitions>{{scope.row.showStatus}}</el-tag>
               </template>
             </el-table-column>
             <el-table-column
                prop="priceRange"
                label="售价"
                >
                <template slot-scope="{row:{ priceRange }}">
                {{ priceRange|| "—" }}
                </template>
             </el-table-column>
             <!-- <el-table-column
                prop="stock"
                label="库存"
                >
                <template slot-scope="{row:{ stock }}">
                {{ stock|| "—" }}
                </template>
             </el-table-column> -->
             <el-table-column
                prop="productDesc"
                label="产品说明"
                show-overflow-tooltip
                >
                <template slot-scope="{row:{ productDesc }}">
                {{ productDesc|| "—" }}
                </template>
             </el-table-column>
             <el-table-column fixed="right" label="操作" width="280">
                <template slot-scope="scope">
                     <i title="编辑" class="el-icon-alixiugai" style="color: #1296db;cursor: pointer;"  @click=bianjiClick(scope.row) ></i>
                     <i title="绑定" class="el-icon-aliwode-bangdingguanxi" v-if="scope.row.bindCount == 0" style="color: #E98F36;cursor: pointer;"  @click=bandingClick(scope.row,1) ></i>
                     <i title="解绑" class="el-icon-aliwode-bangdingguanxi" v-if="scope.row.bindCount > 0" style="color: #E98F36;cursor: pointer;"  @click=jiebangClick(scope.row,2) ></i>
                     <i title="下架" class="el-icon-alixiajia" style="color: #52C891;cursor: pointer;" @click =removefrom(scope.row)></i>
                     <i title="删除" class="el-icon-alishanchu" style="color: #d81e06;cursor: pointer;"  @click=dels(scope.row) ></i>
                </template>
             </el-table-column>
          </el-table>
          <div class="btnbox">
             <el-pagination
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="productQueryPageDto.pageNum"
                     :page-sizes="[10, 15, 20]"
                     :page-size="productQueryPageDto.pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="this.totals">
                  </el-pagination>
               </div>
         </div>
          <!-- 编辑配件类型 -->
         <el-dialog title="编辑配件类型" :visible.sync="increasetypes" width="32%"  >
         <div class="tableform">
            <el-table
               :data="gglxdata"
               border
               stripe
               :cell-style="{'text-align':'center', 'cursor': 'pointer'}"
               :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
               style="width: 100%"
               >
               <el-table-column
               prop="cateName"
               label="规格名称"
               >
               <template slot-scope="{ row: { cateName } }">
                  {{ cateName|| "—" }}
               </template>
               </el-table-column>
               <el-table-column
               prop="remark"
               label="备注信息">
               <template slot-scope="{ row: { remark } }">
                  {{ remark|| "—" }}
               </template>
               </el-table-column>
               <el-table-column fixed="right" label="操作" width="80">
                  <template slot-scope="scope">
                     <el-button type="text" size="small" style="color: #FF2626;" @click="fwlxdels(scope.row)">删除</el-button>
                  </template>
               </el-table-column>
            </el-table>
         </div>
         </el-dialog>
             <!-- 绑定配件 -->
         <el-dialog title="绑定配件" :visible.sync="bdpjincrease" width="52%" class="zcyhtk"  @close='closeDialog'>
               <el-form ref="bindPartsDto" :model="bindPartsDto"  label-width="80px"  class="demo-form-inline">
                  <!-- <el-form-item label="配件类型：">
                     <el-select v-model="listcxpjxx.partsCateId" filterable clearable placeholder="请选择配件类型" @change="valuetimecheack">
                        <el-option
                           v-for="item in yhlxoptions"
                           :key="item.partCateId"
                           :label="item.cateName"
                           :value="item.partCateId">
                        </el-option>
                     </el-select>
                  </el-form-item>
                  <el-form-item label="配件分类：" style="margin-top: 20px;">
                  <el-cascader 
                     :options="fytableData" 
                     v-model="selectedValue" 
                     :props="cascaderProps" 
                     :show-all-levels="false"
                     @change="handleCascaderChange">
                  </el-cascader>
                  </el-form-item> -->
                     <el-form-item label="配件分类：">
                     <el-cascader 
                           :options="xintableData" 
                           v-model="xinselectedValue" 
                           :props="xinaderProps" 
                           :show-all-levels="false"
                           @change="xinCascaderChange">
                        </el-cascader>
                        <!-- <el-button type="primary" @click="pjification()" plain>确定</el-button> -->
                     </el-form-item>
                     <el-form-item>
                     </el-form-item>
                  <div class="product_list">
                     <div class="product_item" v-for="(product, index) in products" :key="index">
                        <img :src="product.mainImage" alt="Product Image" class="product_image" />
                        <img v-if="product.status == '1'" src="../../assets/yxjtp.png" alt="" class="prod_image">
                        <div class="product_details">
                           <p class="product_name">{{ product.partsName }} 
                           <span style="display: inline-block;margin: 0 5px;">/</span> 
                           {{ product.specSku }}</p>
                           <el-input type="number" v-model="product.partsCount" placeholder="请输入产品数量" />
                        </div>
                     </div>
                  </div>
                  </el-form>
               <div slot="footer">
                  <el-button @click="xgtkdfdqx">取 消</el-button>
                  <el-button type="primary" v-if="pdsfybd==1" @click="bdsubmitForm()">确 定</el-button>
                  <el-button type="primary" v-else  @click="jbsubmitForm()">确 定</el-button>
               </div>
         </el-dialog>
   </div>
   </template>
   <script>
import ipConfig from "../../utils/ipconfig";
      export default {
      name:'productlist',
      data(){
       return{
         productQueryPageDto:{
            pageNum:1,
            pageSize:10,
            keyWord:null,
            cateId:null,
            status:null,
         },
          tableData: [],
          totals:10,
          increase:false,
         partsCateAddDto:{
            remark:null,
            cateName:null,
            partsCateId:null,
            cateParentId:null,
         },
         listcxpjxx:{
            partsCateId:null,
            partsName:null,
         },
         ydyoptions: [],
         tabList: [],
         fytableData: [],
         xintableData: [],
         tjlxincrease:false,
         increasetypes:false,
         bdpjincrease:false,
         bindPartsDto:{
            productId:null,
            partsIds:[],
         },
         fyposterPageDto:{
            pageNum:1,
            pageSize:10,
         },
         fytotals:10,
         rules: {
            cateName: [
            { required: true, message: '请输入配件名称', trigger: 'change' }
            ],
            cateParentId: [
               { required: true, message: '请选择测报类型', trigger: 'change' }
            ]
         },
         gglxdata:[],
         yhlxoptions:[],
         datatype:[],
         selectedPartsIds: [],
         categoryPageDto:{
          cateType:0,
          parentCateId:null,
          cateName:null,
        },
         cascaderProps: {
            value: 'variantsId',
            label: 'specSku', 
            multiple: true,
            children: 'partDetailVariantsVos', 
         },
         xinaderProps: {
            value: 'variantsId',
            label: 'specSku', 
            multiple: true,
            children: 'partDetailVariantsVos',
         },
         selectedValue:[],
         xinselectedValue:[],
         products: [],
         duoyigproducts: [],
         cesproducts: [],
         pdsfybd:null,
         ybdsjproducts:[],
         increaselist:[]
       }
      },
      created(){
         this.productQueryPageDto.cateId = this.$route.query.cateId
         this.cpflgetlist(this.categoryPageDto)
      },
      mounted(){
         const currentPage = this.$route.query.pagepageNum || 1;
         // this.this.productQueryPageDto.pageNum = parseInt(currentPage);
         this.getlist(this.productQueryPageDto)
      },
      methods:{
      sjhsearchFor(){
         this.getlist(this.productQueryPageDto)
      },
      cpflgetlist(categoryPageDto) {
          this.$api.cplbbfyqueryList(categoryPageDto)
          .then((res) => {
                if (res.data.code == 200) {
                  this.ydyoptions = res.data.data
               } else {
               this.$message.error(res.data.message)
               }
          })
       },
      newoks() {
         this.$router.push({
            path: "addaccessories",
            query: {
               partsCateId: this.productQueryPageDto.partsCateId,
            },
         });
      },
      bianjiClick(e) {
         const currentPage = this.productQueryPageDto.pageNum;
         this.$router.push({
            path: "producaddtadetail",
            query: {
               productId: e.productId,
               pagepageNum: currentPage,
            },
         });
      },
      jiebangClick(row,type){
         this.pdsfybd = type
         this.bindPartsDto.productId = row.productId
         this.bdpjincrease = true
         this.jiebanglist()
      },
      bandingClick(row,type){
         this.pdsfybd = type
         this.bindPartsDto.productId = row.productId
         this.bdpjincrease = true
        this.xinjeblist()
      },
      xinjeblist(){
            this.$api.queryCascadeParts().then((res) => {
                  if(res.data.code==200){
                     let datalist = res.data.data
                     datalist.forEach(element => {
                        element.specSku = element.cateName
                        this.$set(element, 'partDetailVariantsVos', element.partsVos);
                        element.partDetailVariantsVos.forEach(item => {
                           item.specSku = item.partsName
                           item.partDetailVariantsVos.forEach(row => {
                              row.partsCount = '1'
                              if (row.mainImage) {
                                 if (row.mainImage.startsWith('https://')) {
                                    row.mainImage= row.mainImage
                                 } else {
                                    row.mainImage = ipConfig.baseUrl+row.mainImage
                                 }
                              }else{
                                 row.mainImage = require('@/assets/mrto.png')
                              }
                           });
                        });
                     });
                     this.xintableData= datalist
                  }else{
                     this.$message.error(res.data.message)
                  }
            })
         },
      jiebanglist(){
         this.$api.queryCascadeParts().then((res) => {
                  if(res.data.code==200){
                     let datalist = res.data.data
                     datalist.forEach(element => {
                        element.specSku = element.cateName
                        this.$set(element, 'partDetailVariantsVos', element.partsVos);
                        element.partDetailVariantsVos.forEach(item => {
                           item.specSku = item.partsName
                           item.partDetailVariantsVos.forEach(row => {
                              row.partsCount = '1'
                              if (row.mainImage) {
                                 if (row.mainImage.startsWith('https://')) {
                                    row.mainImage= row.mainImage
                                 } else {
                                    row.mainImage = ipConfig.baseUrl+row.mainImage
                                 }
                              }else{
                                 row.mainImage = require('@/assets/mrto.png')
                              }
                           });
                        });
                     });
                     this.xintableData= datalist
                     this.Inforlistmation()
                  }else{
                     this.$message.error(res.data.message)
                  }
            })
      },
      hqpjlxlist(){
         this.$api.partsList().then((res) => {
               if(res.data.code==200){
                  this.yhlxoptions= res.data.data
               }else{
                  this.$message.error(res.data.message)
               }
         })
      },
      Inforlistmation(){
         this.$api.queryProductParts({
            productId:this.bindPartsDto.productId,
         }).then((res) => {
               if(res.data.code==200){
                  let datalist = []
                  let data = res.data.data.partsBindVos
                  data.forEach(element => {
                     element.variantsId = element.partsVariantId
                     datalist.push(element.partsVariantId)
                     if (element.mainImage) {
                        if (element.mainImage.startsWith('https://')) {
                           element.mainImage= element.mainImage
                        } else {
                           element.mainImage = ipConfig.baseUrl+element.mainImage
                        }
                     }
                  });
                  this.products = data
                  this.cesproducts = data
                  this.xinselectedValue = datalist.map(item => [undefined,undefined, item]);
               }else{
                  this.$message.error(res.data.message)
               }
         })
      },
      handlepartsIdsClick(row){
         if (row.checked) {
            if (!this.selectedPartsIds.includes(row.partVariantsId)) {
               this.selectedPartsIds.push(row.partVariantsId);  // 选中时，添加到 selectedPartsIds
            }
         } 
         else {
            const index = this.selectedPartsIds.indexOf(row.partVariantsId);
            if (index !== -1) {
               this.selectedPartsIds.splice(index, 1);  // 取消选中时，从 selectedPartsIds 中移除
            }
         }
      },
      removefrom(row) {
         this.$confirm('是否确认下架?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
               this.$api.downProduct({
                  productId:row.productId
               }).then((res) => {
                     if(res.data.code==200){
                        this.$message.success(res.data.message)
                        this.getlist(this.productQueryPageDto)
                     }else{
                        this.$message.error(res.data.message)
                     }
               })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });          
            });
      },
      closeDialog(){
        this.xgtkdfdqx()
      },
      getlist(productQueryPageDto) {
          this.$api.cxcplbqueryPage(productQueryPageDto)
          .then((res) => {
            if(res.data.code==200){
               this.tableData = res.data.data.records
               this.tableData.forEach(element => {
                  if (element.status ==0) {
                     element.status ='在售'
                  }else{
                     element.status ='下架'
                  }
                  if (element.showStatus ==0) {
                     element.showStatus ='否'
                  }else{
                     element.showStatus ='是'
                  }
               });
               this.totals = res.data.data.total
            }else{
               this.$message.error(res.data.message)
            }
          })
       },
      newoktypes(){
         this.increasetypes = true
      },
      handleClick(tab, event) {
         this.productQueryPageDto.partsCateId = tab.name
         this.getlist(this.productQueryPageDto)
      },
      tjggnewoks(){
         this.$router.push({
            path: "producaddtlist",
         });
      },
      bdsubmitForm(){
         let productPartsShipDtos=[]
         this.products.forEach(element => {
            let datalist = {
               partsCount:element.partsCount,
               partsId:element.partsId,
               partsPrice:0,
               partsVariantId:element.variantsId,
            }
            productPartsShipDtos.push(datalist)
         });
         this.$api.bdpjbindParts({
            productId:this.bindPartsDto.productId,
            productPartsShipDtos:productPartsShipDtos
         }).then((res) => {
            if (res.data.code == 200) {
               this.bindPartsDto={
                  productId:null,
                  partsIds:[],
               }
               this.bdpjincrease = false
               this.selectedPartsIds=[],
               this.products=[],
               this.pdsfybd=null,
               this.$message.success(res.data.message)
            } else {
            this.$message.error(res.data.message)
            }
         })
      },
      jbsubmitForm() {
         let productPartsShipDtos=[]
         this.products.forEach(element => {
            let datalist = {
               partsCount:element.partsCount,
               partsId:element.partsId,
               partsPrice:0,
               partsVariantId:element.variantsId,
            }
            productPartsShipDtos.push(datalist)
         });
         this.$api.modifyProductParts({
            productId:this.bindPartsDto.productId,
            productPartsShipDtos:productPartsShipDtos
         }).then((res) => {
            if (res.data.code == 200) {
               this.bindPartsDto={
                  productId:null,
                  partsIds:[],
               }
               this.bdpjincrease = false
               this.selectedPartsIds=[],
               this.products=[],
               this.pdsfybd=null,
               this.$message.success(res.data.message)
            } else {
            this.$message.error(res.data.message)
            }
         })
      },
      xgtkdfdqx(){
         this.bindPartsDto={
            productId:null,
            partsIds:[],
         }
         this.bdpjincrease = false
         this.selectedPartsIds=[],
         this.xinselectedValue=[],
         this.products=[],
         this.pdsfybd=null
      },
      fwlxdels(e) {
          this.$confirm('是否确认删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$api.deletePartCate({
               partCateId:e.partCateId
                }).then((res) => {
                  if(res.data.code==200){
                     this.increasetypes = false
                     this.$message.success(res.data.message)
                     this.dataService()
                  }else{
                     this.$message.error(res.data.message)
                  }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });          
            });
        },
        dels(e) {
          this.$confirm('是否确认删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$api.expurgate({
               productId:e.productId
                }).then((res) => {
                  if(res.data.code==200){
                     this.getlist(this.productQueryPageDto)
                     this.$message.success(res.data.message)
                  }else{
                     this.$message.error(res.data.message)
                  }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });          
            });
        },
      handleCurrentChange(val) {
         this.productQueryPageDto.pageNum = val
         this.getlist(this.productQueryPageDto)
      },
      handleSizeChange(val) {
         this.productQueryPageDto.pageSize = val
         this.getlist(this.productQueryPageDto)
      },
      valuetimecheack(value){
         this.cxpjxxlist(value)
      },
      cxpjxxlist(partsCateId){
         this.$api.queryPartsList({
            partsCateId:partsCateId,
         }).then((res) => {
               if(res.data.code==200){
                  let data = res.data.data
                  // let datalist = []
                  data.forEach(element => {
                     element.partVariantsId= element.partVariantsId
                     element.specSku= element.partsName
                     element.partDetailVariantsVos.forEach(item => {
                        // datalist.push(item.variantsId)
                        item.partDetailVariantsVos = null
                     });
                  });
                  // this.selectedValue = datalist.map(item => [undefined, item]);
                  this.fytableData = data
               }else{
                  this.$message.error(res.data.message)
               }
         })
      },
      handleCascaderChange(value) {
         let xuypush = []
         this.products = []
         const resultArray = value.map(item => item[1]);
         resultArray.forEach(item => {
            const selectedOption = this.findOptionById(item, this.fytableData);
            xuypush.push(selectedOption)
         });
            let datalist = xuypush
            datalist.forEach(element => {
               if (element.mainImage) {
                  if (element.mainImage.startsWith('https://')) {
                     element.mainImage= element.mainImage
                  } else {
                     element.mainImage = ipConfig.baseUrl+element.mainImage
                  }
               }
            });
            const mergedArray = [...this.products, ...datalist];
            // this.products = datalist
            // this.methoddxyg(mergedArray)
      },
      // methoddxyg(mergedArray){
      //    if (this.products.length == 0) {
      //       this.products = [...datalist];
      //    } else {
      //       mergedArray = [...this.products, ...datalist];
      //       this.products = mergedArray.filter((value, index, self) =>
      //          index === self.findIndex((t) => t.variantsId === value.variantsId)
      //       );
      //    }
      // },
      findOptionById(variantsId, options) {
         for (let option of options) {
            if (option.variantsId == variantsId) {
               return option;
            }
            if (option.partDetailVariantsVos) {
               const found = this.findOptionById(variantsId, option.partDetailVariantsVos);
               if (found) return found;
            }
         }
         return null;
      },
      xinCascaderChange(value){
         let xuypush = []
         this.products = []
         const resultArray = value.map(item => item[2]);
         resultArray.forEach(item => {
            const selectedOption = this.findOptionById(item, this.xintableData);
            xuypush.push(selectedOption)
         });
         const copiedArray = JSON.parse(JSON.stringify(xuypush));
         let datalist = copiedArray
         let duoyigproducts = []
         if (this.products.length == 0) {
            duoyigproducts = [...datalist];
         } else {
            const mergedArray = [...this.products, ...datalist];
            duoyigproducts = mergedArray.filter((value, index, self) =>
               index === self.findIndex((t) => t.variantsId === value.variantsId)
            );
         }
         this.methoddxyg(duoyigproducts)
      },
      methoddxyg(duoyigproducts){
         duoyigproducts.forEach(item1 => {
            const matchedItem = this.cesproducts.find(item2 => item2.variantsId === item1.variantsId);
            if (matchedItem) {
               item1.partsCount = matchedItem.partsCount;
            }
         });
         this.products = duoyigproducts
      },
      pjification(){
         // this.products = this.duoyigproducts
      }
      }
      }
   </script>
   <style scoped>
#productlist {
   width: 100%;
   height: 100%;
   overflow-y: auto;
   background-color: #fff;
   padding:0 0 0 30px;
   box-sizing: border-box;
}
.tos {
   display: flex;
   /* justify-content: space-between; */
   align-items: center;
   /* background: yellow; */
   margin-bottom: 20px;
   margin-left: -30px;
 }
 .elrow{
   box-sizing: border-box;
   width: 20%;
   margin-top: -6px;
   margin: 0 40px 0 20px;
 }
 .elrowleft{
   width: 80%;
   float: left;
   box-sizing: border-box;
 }
 .elrowleft input{
   border: 2px solid #1b93ed !important;
   border-radius: 0 !important;
   width: 100%;
   -webkit-appearance: none;
   appearance: none;
   background-color: #fff;
   background-image: none;
   border-radius: 4px;
   border: 1px solid #929da5;
   box-sizing: border-box;
   color: #1f3d35;
   font-size: 14px;
   height: 36px;
   line-height: 1;
   outline: none;
   padding: 3px 10px;
   transition: border-color .2s cubic-bezier(.645,.045,.355,1);
 }
 .elrowcontent{
   width: 16.66667%;
   float: left;
   box-sizing: border-box;
 }
 .search-btn {
   height: 36px;
   width: 100px;
   background: #1b93ed;
   border: 2px solid #1b93ed;
   margin: 0;
   padding: 0;
   color: #fff;
   cursor: pointer;
 }
 .left_item{
   margin-left: auto;
 }
 .right-item {
   margin-left: auto; 
 }
 .tos /deep/ .el-form-item {
     margin-bottom: 0 !important;
 }
 .btnbox {
       display: flex;
       width: 40%;
       align-items: center;
       justify-content: space-around;
       margin: auto;
       margin-top: 30px;
   }
.tjannos{
   display: flex;
   margin-bottom: 20px;
 }
   .zcyhtk /deep/ .el-form-item__label {
      width: 90px !important;
   }
  .zcyhtk /deep/ .el-form-item__content {
    margin-left: 90px !important;
  }
   .zcyhtk /deep/ .el-select {
      width: 100%;
   }
   .zcyhtk /deep/ .el-cascader {
      width: 90%;
   }
   .image-column {
      width: 50px; 
      height: 50px;
      object-fit: cover;
   }
   .fytableform{
      margin-left: 35px;
   }
   .product_list {
      display: flex;
      flex-wrap: wrap; /* 让产品在没有足够空间时换行 */
      gap: 20px; /* 给每个产品之间添加间距 */
      justify-content: flex-start; /* 靠左对齐 */
      margin-left: 90px;
   }
   .product_item {
      display: flex;
      flex-direction: column;
      align-items: flex-start; /* 对齐产品信息 */
      padding: 10px;
      border: 1px solid #ddd;
      border-radius: 8px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      position: relative;
   }
   .product_image {
      width: 100%;
      height: 128px;
      border-radius: 5px;
      object-fit: cover;
   }
   .prod_image{
      position: absolute;
      top: 0;
      right: 0;
      width: 80px;
      height: 80px;
      object-fit: cover;
   }
   .product_details {
      display: flex;
      flex-direction: column;
      align-items: flex-start; /* 保证产品详情靠左对齐 */
   }
   .product_name {
      font-size: 14px;
      color: #333333;
   }
   </style>


// WEBPACK FOOTER //
// src/components/productlist/productlist.vue